import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
// import Home from "./pages/Home";
import Detail from "./pages/Detail";

import "./App.scss";

class App extends Component {
  componentDidMount() {}

  render() {
    return (
      <div>
        <Switch>
          <Route path="/" component={Detail} />
          {/* <Route path="/" component={Home} /> */}
        </Switch>
      </div>
    );
  }
}

export default App;
